/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  position: relative;
  margin: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  border-width: 1px;
  border-style: solid;
  border-color: var(--calcite-color-border-2);
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  color: var(--calcite-color-text-2);
}
:host * {
  box-sizing: border-box;
}

.container {
  inline-size: 100%;
  padding: 1rem;
}

:host([closed]),
:host([closed]) .container {
  display: none;
}

:host([selected]) .container {
  margin: 0px;
  border-style: none;
  padding: 0px;
}

/* Shared styles for header elements */
.header {
  margin: 0px;
  display: flex;
  align-content: space-between;
  align-items: center;
  fill: var(--calcite-color-text-2);
  color: var(--calcite-color-text-2);
}

.heading {
  margin: 0px;
  padding: 0px;
  font-weight: var(--calcite-font-weight-medium);
}

.header .heading {
  flex: 1 1 auto;
  padding: 0.5rem;
}

.header {
  margin-block-end: 0.5rem;
}

.header .heading {
  padding: 0px;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  color: var(--calcite-color-text-1);
}

.container[hidden] {
  display: none;
}

.content {
  display: flex;
}

.info {
  padding-block: 0px;
  padding-inline: 1rem;
  inline-size: 70%;
}
.info:only-child {
  inline-size: 100%;
  padding-inline: 0px;
}

::slotted(p) {
  margin-block-start: 0px;
}

::slotted(a) {
  outline-color: transparent;
  color: var(--calcite-color-brand);
}

::slotted(a:focus) {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.image-frame {
  inline-size: 25%;
}
.image-frame img {
  max-inline-size: 100%;
}

::slotted(img) {
  max-inline-size: 100%;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}